// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__31M8Y","content":"styles_content__33LAz","checkbox":"styles_checkbox__7jRHA","checkboxLabel":"styles_checkboxLabel__2X3s-"};